function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "sexy2");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M90.21,87.17,78.6,99.45l11.87,11.23-7.21,7.62-29.55-28,7.21-7.62L72,93.16,83.57,80.88l-11-10.44,7.21-7.61,29.55,28-7.22,7.62Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M131.34,67.55l-13.9,9.61,1.8,6.25-9.38,6.49L99.3,47.73l10.84-7.49,35.79,24.7-9.38,6.5Zm-16.67.78,9.38-6.49L109.92,51.51Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.87,27.62l18.65-8.19c8.38-3.68,15.44,0,18.41,6.72s.78,14.24-7.6,17.92l-9.05,4,5.54,12.62-9.61,4.22Zm20.92.48L144,31.5l3.67,8.38,7.77-3.41c2.57-1.12,3.76-3.58,2.65-6.09A4.54,4.54,0,0,0,151.79,28.1Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M172.4,10.7l19.84-4.64c8.9-2.08,15.18,2.78,16.86,10s-1.83,14.14-10.74,16.22l-9.62,2.25,3.14,13.43-10.22,2.38ZM192.88,15l-8.25,1.93,2.08,8.91L195,23.9c2.73-.64,4.34-2.83,3.72-5.5A4.55,4.55,0,0,0,192.88,15Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M228.07,25.42,211.55,1.87l11.82-.54,9.52,14.59,8-15.38L252.8,0,238.55,25l.74,16.39-10.48.48Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.54,2.84,302,7.91c7.85,1.77,10.45,7.74,9.32,12.74s-4.9,7.58-8.84,7.57c4.08,1.61,6.5,6.41,5.37,11.4-1.3,5.78-6.3,9.9-14.09,8.14l-23.21-5.23ZM293,38.65c2.44.55,4.26-.6,4.75-2.74a3.77,3.77,0,0,0-3.09-4.64L284.41,29l-1.67,7.38Zm3.21-15.91a3.44,3.44,0,0,0,4.29-2.66,3.39,3.39,0,0,0-2.74-4.18l-9.94-2.24-1.54,6.84Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M323.72,14.47l9.82,3.71L319.17,56.24l-9.82-3.7Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M345.43,53.46l-4.72-2.56L334.14,63l-9.22-5,19.37-35.78L362.2,32c7.94,4.3,9.6,12,6,18.65-3.37,6.22-9,7.48-12.94,6.86l.18,17.1-10.57-5.73ZM356.6,39,349.3,35l-4.35,8,7.29,4c2.41,1.31,5.3.86,6.63-1.61S359,40.28,356.6,39Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M384.75,57.67l-8.91-7.11,5.71-7.15,26,20.73-5.71,7.15L393,64.22,373.28,88.86l-8.2-6.54Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M414.77,108.25,403.82,95.38,391.37,106l-6.8-8,31-26.36,6.8,8-11.57,9.84,10.95,12.87,11.56-9.84,6.8,8-31,26.36-6.79-8Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M447.88,111.94l8.1,15c6.07,11.28,3.67,23-7.44,29s-22.31,1.55-28.35-9.67l-8.13-15.1Zm-19.67,30c3.39,6.29,9.92,7.48,15.24,4.62,5.53-3,8-8.63,4.5-15.18l-3.15-5.85-19.71,10.61Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M444.45,190.17l-5-16.15-6.5-.16L429.61,163,473,165.58l3.88,12.59-34.34,26.7L439.18,194ZM448.73,174l3.37,10.89,14.1-10.35Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M459.14,211.15,481.3,192.8l1.48,11.74L469,215.19,485,222l1.49,11.8-26-12.22-16.28,2.05-1.31-10.41Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M457.74,284.09l27-10-2.49,11.57-16.53,5.49,12.84,11.68L476,314.48l-20.5-20.13-16-3.46,2.2-10.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M467.13,338.31c-4.72,11.52-16.25,16.81-27.71,12.12s-16-16.56-11.24-28.07,16.27-16.87,27.73-12.18S471.84,326.8,467.13,338.31Zm-8.58-3.51c2.56-6.27-.54-12.22-6.69-14.74s-12.53-.45-15.1,5.81.61,12.19,6.71,14.68S456,341,458.55,334.8Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M451.54,369.08l-6.19,8.69-19.42-13.85c-3.93-2.79-8.24-2.72-11.54,1.9s-1.91,8.67,2,11.47l19.42,13.84-6.2,8.69L410,385.8c-8.24-5.88-10.69-14.74-3.12-25.37s16.84-11.22,25-5.41Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M381.63,431.5,391,425l5.26,7.49L369,451.54l-5.25-7.49,9.29-6.52-18.12-25.82,8.59-6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M324.68,446.1l15.42-6.91-6.68-14.92L343,420l16.64,37.13-9.58,4.29-6.21-13.86-15.42,6.91,6.21,13.86-9.57,4.29-16.64-37.13,9.58-4.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M312.4,476.43l-29,6.83-2-8.61,18.82-4.43-1.55-6.59L280.21,468l-2-8.67,18.4-4.33-1.67-7.13-18.83,4.43-2-8.61,29-6.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M253.53,458.88l8.16-14.09,12.43-.61L261,465.72l14.26,19.14-12.37.61-8.61-12.34L247,486.26l-12.43.61,12.24-20.39-15.17-20.2,12.37-.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M217.18,475.63l11.3,1.52-1.22,9.07-32.94-4.44,1.22-9.06,11.24,1.51L211,443l10.39,1.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M165.46,447.7l16,5.4,5.22-15.49,9.94,3.35-13,38.55-9.94-3.35,4.85-14.39-16-5.4-4.85,14.39-9.94-3.36,13-38.55,9.94,3.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M138.09,435.05l1.22,28.75-10.25-5.92-.15-17.42-15.06,8.63-10.3-5.95L129,429.8l8.21-14.21,9.09,5.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M69.55,414.06l-15-17.54c-5.22-6.13-3.72-12.46.17-15.78s8.47-3.14,11.62-.77c-2.3-3.73-1.37-9,2.53-12.35,4.5-3.84,11-4.15,16.16,1.93l15.44,18.1ZM68.1,388.11a3.45,3.45,0,0,0-5-.44,3.41,3.41,0,0,0-.31,5l6.62,7.75,5.33-4.56ZM80.21,377.3c-1.63-1.9-3.78-2.07-5.45-.64a3.76,3.76,0,0,0-.31,5.55l6.85,8,5.76-4.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M40.12,377.35,25.2,351.52l7.66-4.43,9.67,16.75,5.86-3.39-9.46-16.38,7.72-4.45L56.11,356l6.33-3.67-9.67-16.74,7.66-4.43L75.35,357Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M44,304.82l5.63,15.93,6.5-.1,3.81,10.76-43.47-.87L12,318.12l33.23-28.06,3.81,10.75Zm-3.62,16.29-3.8-10.75L22.86,321.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M13.86,288.71l2,11.23-9,1.58L1.07,268.78l9-1.58,2,11.18,31.07-5.45,1.81,10.33Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M24.83,231l-.31,16.89,16.35.3-.19,10.49L0,257.9l.19-10.49,15.19.27.3-16.89L.5,230.52.69,220l40.68.74-.2,10.48Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M13.49,199.91l-2.38,11.15-8.95-1.91,7-32.5,9,1.91-2.37,11.09,30.83,6.6L44.33,206.5Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48.26,
  cy: 144.67,
  r: 7
})));

var SvgSexy2 = function SvgSexy2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 486.46 486.87",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSexy2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sexy2.64f4c986.svg";
export { ForwardRef as ReactComponent };